import { CampoDinamico } from '../campo-dinamico';
import { DescrittoreSezione } from '../descrittore-sezione';
import { PraticaBase } from '../pratica/pratica-base';
import { AutoritaGiudiziaria } from '../tipologiche/autorita-giudiziaria';
import { SedeTerritoriale } from '../tipologiche/sede-territoriale';
import { CopertinaFascicolo } from './copertina-fascicolo';
import { FascicoloLight } from './fascicolo-light';
import { Rifiuto } from './rifiuto';
import {QuestionBase} from "../../../core/components/dynamic-form/models/question-base";
import { TipoVisibilita } from '../tipologiche/tipo-visibilita';
import { TipoTipologiaGenericoGiudiziale } from '../tipologiche/tipo-tipologia-generico-giudiziale';
import { TipoTipologiaGenericoConsulenza } from '../tipologiche/tipo-tipologia-generico-consulenza';

export class FascicoloFull extends FascicoloLight {
  campiDinamici: CampoDinamico[];
  praticaBase: PraticaBase;
  copertina: CopertinaFascicolo;
  descrittoriSezione: DescrittoreSezione[]; // TO CHECK
  rifiuto: Rifiuto;
  numeroRuolo: string;
  annoRuolo: number;
  recuperoCrediti?: boolean;
  // ID SEZIONE VANNO SPOSTATI NELLA VERTICALE DEL FASCICOLO!!!!

  idSezioneControparti: string;
  idSezionePatologie: string;
  idSezioneSchedeRecupero: string;
  idSezioneSchedeEsecuzione: string;
  idSezioneLegali: string;
  idSezioneAltreParti: string;
  idSezioneReati: string;
  idSezioneDatiEconomici: string;
  idSezioneFatture: string;
  idSezioneIncassi: string;
  idSezionePagamenti: string;
  idSezioneParcelle: string;
  idSezioneScadenze: string;
  idSezioneEsiti: string;
  idSezioneAtti: string;
  idSezioneDocumentazioneAllegata: string;
  idSezioneReferenti: string;
  idSezioneBeniPignoratiImmobili: string;
  idSezioneProveScritte: string;
  idSezioneBeniPignoratiMobili: string;
  idSezioneLettereDiffida: string;
  idSezioneTitoliEsecutivi: string;
  idSezioneCensimentoDocumenti: string;
  idSezioneDatiPignoramento: string;
  numeroProtocollo: string;
  numeroFascicoloProtocollo: string;
  dataProtocollazione: number;
  oggettoProtocollo: string;
  senderReceiver:string;
  utenteProtocollatore:string;
  // Questi dati non sono presenti per tutti i fascicoli. Sono solo nei fascicoli giudiziali
 /* fascicoloCapofila: FascicoloFull;*/
  fascicoliRiuniti: FascicoloFull[];
  dataRiunioneGiudizio: number;
  motivoRiunioneGiudizio: string;
  capofila: boolean;
  riunito: boolean;
  autoritaGiudiziaria: AutoritaGiudiziaria;
  autoritaGiudiziariaCitta: SedeTerritoriale;
  giudice: string;
  tipologiaGenericoGiudiziale: TipoTipologiaGenericoGiudiziale;
  tipologiaGenericoConsulenza: TipoTipologiaGenericoConsulenza;

  get baseForm(): QuestionBase[] {
    return [
      {
        key: 'dataInizioFascicolo',
        label: 'Data apertura',
        required: true,
        controlType: 'date',
        placeholder: 'Inserire Data apertura',
        size: 'sm-6',
        value: this.dataInizioFascicolo
      },
      {
        key: 'dataNotifica',
        label: 'Data notifica',
        required: false,
        controlType: 'date',
        placeholder: 'Inserire Data notifica',
        size: 'sm-6',
        value: this.dataNotifica
      },
      {
        key: 'natura',
        label: 'Natura',
        required: true,
        controlType: 'dropdown',
        placeholder: 'Inserire natura',
        size: 'sm-6',
        value: this.natura
      },
      {
        key: 'flagFondoRischi',
        label: 'Fondo rischi',
        required: false,
        controlType: 'radio',
        size: 'sm-6',
        value: this.flagFondoRischi
      },
      {
        key: 'note',
        label: 'Note',
        required: false,
        controlType: 'textarea',
        placeholder: 'Inserire Note',
        size: 'sm-12',
        value: this.note
      }
    ] as QuestionBase[]
  }
}
